import React from 'react';
import { Loader } from '../..';


export default function WhaleTransaction(props) {
  const { analyze, loading } = props;
  return (
    <>
      <div className="tableLastTrans table-responsive tableScroll scrollCustom" style={{ height: 400 }}>
        <table className="table table-borderless table-hover">
          <thead>
            <tr>
              <th>No</th>
              <th>Contract Address</th>
              <th>Simbol</th>
              <th>Net Transfer</th>
            </tr>
          </thead>
          <tbody>
            {
              analyze && analyze.map((item, key) => {
                return (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{item.contract_address}</td>
                    <td>{item.symbol}</td>
                    <td>{item.real_net_transfer}</td>
                  </tr>
                )
              })
            }
            {
              !analyze && <tr><td className="text-center" colSpan={4}>No data...</td></tr>
            }
          </tbody>
        </table>
      </div>
      {
        loading && <Loader />
      }
    </>
  )
}
